import { useEffect, useState } from "react";
import { Download, FileText } from "lucide-react";
import client, { extractError } from "@/api";

export const CompanyMembershipAgreementPanel = () => {
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busyId, setBusyId] = useState("");

  useEffect(() => {
    client.get("/membership-agreements")
      .then((response) => setAgreements(Array.isArray(response.data) ? response.data : []))
      .catch((requestError) => setError(extractError(requestError, "Unable to load your membership agreement.")))
      .finally(() => setLoading(false));
  }, []);

  const download = async (agreement) => {
    setBusyId(agreement.id); setError("");
    try {
      const response = await client.get(`/membership-agreements/${agreement.id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(response.data);
      window.open(url, "_blank", "noopener");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (requestError) {
      setError(extractError(requestError, "Unable to download your agreement."));
    } finally {
      setBusyId("");
    }
  };

  return (
    <section className="credit-panel agreement-panel" data-testid="company-membership-agreement-panel">
      <div className="section-heading">
        <div><p className="eyebrow">MEMBERSHIP AGREEMENT</p><h3>Business Membership &amp; Barter Credit</h3></div>
        <FileText size={20} />
      </div>
      {loading && <p className="muted small" data-testid="company-agreements-loading">Loading agreement…</p>}
      {error && <div className="form-error small" data-testid="company-agreements-error">{error}</div>}
      {!loading && agreements.length === 0 && <p className="muted small" data-testid="company-agreements-empty">Your agreement will appear here after membership activation.</p>}
      <div className="agreement-list">
        {agreements.map((agreement) => (
          <article key={agreement.id} className="agreement-record" data-testid={`company-agreement-${agreement.id}`}>
            <div className="agreement-record-heading">
              <div><strong data-testid={`company-agreement-number-${agreement.id}`}>{agreement.agreement_number}</strong><small data-testid={`company-agreement-plan-${agreement.id}`}>{agreement.membership_plan_name}</small></div>
              <span className={`chip ${agreement.status === "GENERATED" ? "chip-success" : "chip-warning"}`} data-testid={`company-agreement-status-${agreement.id}`}>{agreement.status}</span>
            </div>
            <dl className="agreement-details">
              <div><dt>Allocated Credit</dt><dd data-testid={`company-agreement-credit-${agreement.id}`}>₹{Number(agreement.allocated_barter_credit_limit).toLocaleString("en-IN")}</dd></div>
              <div><dt>Security Cheque Amount</dt><dd data-testid={`company-agreement-cheque-amount-${agreement.id}`}>₹{Number(agreement.security_cheque_amount).toLocaleString("en-IN")}</dd></div>
              <div><dt>Generated Date</dt><dd data-testid={`company-agreement-generated-date-${agreement.id}`}>{agreement.generated_at ? new Date(agreement.generated_at).toLocaleDateString() : "—"}</dd></div>
            </dl>
            {agreement.status === "GENERATED" && (
              <button type="button" className="ghost-button" onClick={() => download(agreement)} disabled={busyId === agreement.id} data-testid={`company-agreement-download-${agreement.id}`}>
                <Download size={15} /> Download agreement
              </button>
            )}
          </article>
        ))}
      </div>
    </section>
  );
};